<template>
    <div class="case">
        <div class="headline">{{ $t('headline.title3') }}</div>
        <div class="cases">
            <div class="caseItem" v-for="(item, index) in 3">
                <div class="img">
                    <img :src="`https://4d-ai.chat/img/al${index + 1}.jpg`">
                </div>
                <div class="main">
                    <div class="name">{{ $t(`cases.title${index + 1}`) }}</div>
                    <div class="device">{{ $t(`cases.device${index + 1}`) }}</div>
                    <div class="content">{{ $t(`cases.content${index + 1}`) }}</div>
                    <div class="list">
                        <div class="item">{{ $t(`cases.msg${index + 1}1`) }}</div>
                        <div class="item">{{ $t(`cases.msg${index + 1}2`) }}</div>
                        <div class="item">{{ $t(`cases.msg${index + 1}3`) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .case {
        padding: 50px 10px 10px !important;
    }

    .cases {
        gap: 15px !important;
    }

    .img {
        flex: 1.5 !important;
        height: 100% !important;
        overflow: hidden !important;
        border-radius: 15px !important;
    }

    img {
        border-radius: 15px !important;
    }

    .main {
        flex: 2 !important;
    }

    .name {
        font-size: 18px !important;
    }

    .device {
        font-size: 14px !important;
    }

    .content {
        font-size: 12px !important;
    }

    .caseItem {
        height: auto !important;
    }

    .list {
        font-size: 10px !important;
        gap: 3px !important
    }

}
</style>
<style scoped lang="less">
.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}

.case {
    background-color: #f9fafb;
    padding: 80px 212px;
    box-sizing: border-box;

    .cases {
        display: flex;
        flex-direction: column;
        gap: 64px;

        .caseItem {
            box-shadow: 0 2px 8px #0000001a;
            height: 464px;
            width: 100%;
            background-color: #fff;
            border-radius: 15px;
            padding: 32px;
            box-sizing: border-box;
            display: flex;
            gap: 50px;
            align-items: center;

            .main {
                flex: 1;

                .name {
                    font-size: 24px;
                    color: #243c8a;
                    font-weight: 600;
                    margin-bottom: 8px;
                }

                .device {
                    font-size: 20px;
                    color: #2b52d8;
                    margin-bottom: 16px;
                }

                .content {
                    color: #4c5563;
                    font-size: 16px;
                    margin-bottom: 24px;
                }

                .list {
                    color: #384151;
                    font-size: 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
            }

            .img {
                width: 688px;
                height: 100%;
                overflow: hidden;
                border-radius: 15px;

                img:hover {
                    transform: scale(1.2);
                }

                img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.6s;
                }
            }
        }
    }

}
</style>